import React, { useEffect } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { blogPostsBySlug } from './blogPosts';
import './BlogPage.css';

const BlogPostPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const post = slug ? blogPostsBySlug[slug] : undefined;

  useEffect(() => {
    if (!post) return;

    const previousTitle = document.title;
    const nextTitle = `${post.title} | Glistar.ai Blog`;
    document.title = nextTitle;

    const metaName = 'description';
    const previousDescription = document.querySelector(`meta[name="${metaName}"]`)?.getAttribute('content') || '';

    let metaDescription = document.querySelector(`meta[name="${metaName}"]`) as HTMLMetaElement | null;
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = metaName;
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = post.description;

    return () => {
      document.title = previousTitle;
      const currentMetaDescription = document.querySelector(`meta[name="${metaName}"]`) as HTMLMetaElement | null;
      if (currentMetaDescription) {
        currentMetaDescription.content = previousDescription;
      }
    };
  }, [post]);

  if (!post) {
    return <Navigate to="/blog" replace />;
  }

  return (
    <div className="blog-page">
      <Header />

      <main id="main" className="blog-main">
        <article className="blog-post-container">
          <Link to="/blog" className="blog-back-link">
            ← Back to blog
          </Link>
          <p className="blog-card-meta blog-post-meta">
            <span>{post.category}</span>
            <span>{post.publishDate}</span>
          </p>
          <h1 className="blog-post-title">{post.title}</h1>
          <p className="blog-post-description">{post.description}</p>

          <div className="blog-content">{post.content}</div>
        </article>
      </main>

      <Footer />
    </div>
  );
};

export default BlogPostPage;
